export default __webpack_public_path__ + "static/media/pic5.1c78e51a.jpg";